import { DonutChartBaseConfig } from '../donut-chart-base-config';

/**
 * A config containing properties for the sparkline chart
 */
export class DonutChartConfig extends DonutChartBaseConfig {
}
